import { default as callback7S2Odl1bA8Meta } from "C:/sb/workspace/sbform/src/pages/cc/mb/callback.vue?macro=true";
import { default as callbackY14extwgXlMeta } from "C:/sb/workspace/sbform/src/pages/cc/ym/callback.vue?macro=true";
import { default as anshin_45data_45boxzp6M2XN41HMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/anshin-data-box.vue?macro=true";
import { default as callbackYZ8XWkLLZRMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/callback.vue?macro=true";
import { default as common_45formUSjU8RS8LFMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/common-form.vue?macro=true";
import { default as errorcfuDLQcsMPMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/error.vue?macro=true";
import { default as formaDc60ywuhMMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/form.vue?macro=true";
import { default as historyNHgpjNnjV2Meta } from "C:/sb/workspace/sbform/src/pages/contact/cf/history.vue?macro=true";
import { default as kirUFEjAvAkewMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/kir.vue?macro=true";
import { default as messagestVGAUCAd3uMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/messages.vue?macro=true";
import { default as sattoSAdVj8SS9nMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/satto.vue?macro=true";
import { default as shop_45smartphone_45supportvfPeODFT7JMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/shop-smartphone-support.vue?macro=true";
import { default as success6vyFx8ulnrMeta } from "C:/sb/workspace/sbform/src/pages/contact/cf/success.vue?macro=true";
import { default as callback_45reservebXNjSVEpRgMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/callback-reserve.vue?macro=true";
import { default as contract_45switchlQBQV3ZetXMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/contract-switch.vue?macro=true";
import { default as m_4500rIHyclOudEMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-00.vue?macro=true";
import { default as m_4501gY78oKm1MVMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-01.vue?macro=true";
import { default as m_4502OokD6e7MeFMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-02.vue?macro=true";
import { default as m_45039h16O6NGW1Meta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-03.vue?macro=true";
import { default as m_4504qy5W5HH8xoMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-04.vue?macro=true";
import { default as m_4507oj8NC9tlakMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-07.vue?macro=true";
import { default as m_45086ThglOICLNMeta } from "C:/sb/workspace/sbform/src/pages/contact/en/m-08.vue?macro=true";
import { default as touch_45de_45mail0pjKU81WDkMeta } from "C:/sb/workspace/sbform/src/pages/contact/mb/touch-de-mail.vue?macro=true";
import { default as saponaviyHxKNs9IWJMeta } from "C:/sb/workspace/sbform/src/pages/contact/ym/saponavi.vue?macro=true";
import { default as indexAMyVc8flIhMeta } from "C:/sb/workspace/sbform/src/pages/index.vue?macro=true";
export default [
  {
    name: callback7S2Odl1bA8Meta?.name ?? "cc-mb-callback",
    path: callback7S2Odl1bA8Meta?.path ?? "/cc/mb/callback",
    meta: callback7S2Odl1bA8Meta || {},
    alias: callback7S2Odl1bA8Meta?.alias || [],
    redirect: callback7S2Odl1bA8Meta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/cc/mb/callback.vue").then(m => m.default || m)
  },
  {
    name: callbackY14extwgXlMeta?.name ?? "cc-ym-callback",
    path: callbackY14extwgXlMeta?.path ?? "/cc/ym/callback",
    meta: callbackY14extwgXlMeta || {},
    alias: callbackY14extwgXlMeta?.alias || [],
    redirect: callbackY14extwgXlMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/cc/ym/callback.vue").then(m => m.default || m)
  },
  {
    name: anshin_45data_45boxzp6M2XN41HMeta?.name ?? "contact-cf-anshin-data-box",
    path: anshin_45data_45boxzp6M2XN41HMeta?.path ?? "/contact/cf/anshin-data-box",
    meta: anshin_45data_45boxzp6M2XN41HMeta || {},
    alias: anshin_45data_45boxzp6M2XN41HMeta?.alias || [],
    redirect: anshin_45data_45boxzp6M2XN41HMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/anshin-data-box.vue").then(m => m.default || m)
  },
  {
    name: callbackYZ8XWkLLZRMeta?.name ?? "contact-cf-callback",
    path: callbackYZ8XWkLLZRMeta?.path ?? "/contact/cf/callback",
    meta: callbackYZ8XWkLLZRMeta || {},
    alias: callbackYZ8XWkLLZRMeta?.alias || [],
    redirect: callbackYZ8XWkLLZRMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/callback.vue").then(m => m.default || m)
  },
  {
    name: common_45formUSjU8RS8LFMeta?.name ?? "contact-cf-common-form",
    path: common_45formUSjU8RS8LFMeta?.path ?? "/contact/cf/common-form",
    meta: common_45formUSjU8RS8LFMeta || {},
    alias: common_45formUSjU8RS8LFMeta?.alias || [],
    redirect: common_45formUSjU8RS8LFMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/common-form.vue").then(m => m.default || m)
  },
  {
    name: errorcfuDLQcsMPMeta?.name ?? "contact-cf-error",
    path: errorcfuDLQcsMPMeta?.path ?? "/contact/cf/error",
    meta: errorcfuDLQcsMPMeta || {},
    alias: errorcfuDLQcsMPMeta?.alias || [],
    redirect: errorcfuDLQcsMPMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/error.vue").then(m => m.default || m)
  },
  {
    name: formaDc60ywuhMMeta?.name ?? "contact-cf-form",
    path: formaDc60ywuhMMeta?.path ?? "/contact/cf/form",
    meta: formaDc60ywuhMMeta || {},
    alias: formaDc60ywuhMMeta?.alias || [],
    redirect: formaDc60ywuhMMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/form.vue").then(m => m.default || m)
  },
  {
    name: historyNHgpjNnjV2Meta?.name ?? "contact-cf-history",
    path: historyNHgpjNnjV2Meta?.path ?? "/contact/cf/history",
    meta: historyNHgpjNnjV2Meta || {},
    alias: historyNHgpjNnjV2Meta?.alias || [],
    redirect: historyNHgpjNnjV2Meta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/history.vue").then(m => m.default || m)
  },
  {
    name: kirUFEjAvAkewMeta?.name ?? "contact-cf-kir",
    path: kirUFEjAvAkewMeta?.path ?? "/contact/cf/kir",
    meta: kirUFEjAvAkewMeta || {},
    alias: kirUFEjAvAkewMeta?.alias || [],
    redirect: kirUFEjAvAkewMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/kir.vue").then(m => m.default || m)
  },
  {
    name: messagestVGAUCAd3uMeta?.name ?? "contact-cf-messages",
    path: messagestVGAUCAd3uMeta?.path ?? "/contact/cf/messages",
    meta: messagestVGAUCAd3uMeta || {},
    alias: messagestVGAUCAd3uMeta?.alias || [],
    redirect: messagestVGAUCAd3uMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/messages.vue").then(m => m.default || m)
  },
  {
    name: sattoSAdVj8SS9nMeta?.name ?? "contact-cf-satto",
    path: sattoSAdVj8SS9nMeta?.path ?? "/contact/cf/satto",
    meta: sattoSAdVj8SS9nMeta || {},
    alias: sattoSAdVj8SS9nMeta?.alias || [],
    redirect: sattoSAdVj8SS9nMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/satto.vue").then(m => m.default || m)
  },
  {
    name: shop_45smartphone_45supportvfPeODFT7JMeta?.name ?? "contact-cf-shop-smartphone-support",
    path: shop_45smartphone_45supportvfPeODFT7JMeta?.path ?? "/contact/cf/shop-smartphone-support",
    meta: shop_45smartphone_45supportvfPeODFT7JMeta || {},
    alias: shop_45smartphone_45supportvfPeODFT7JMeta?.alias || [],
    redirect: shop_45smartphone_45supportvfPeODFT7JMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/shop-smartphone-support.vue").then(m => m.default || m)
  },
  {
    name: success6vyFx8ulnrMeta?.name ?? "contact-cf-success",
    path: success6vyFx8ulnrMeta?.path ?? "/contact/cf/success",
    meta: success6vyFx8ulnrMeta || {},
    alias: success6vyFx8ulnrMeta?.alias || [],
    redirect: success6vyFx8ulnrMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/cf/success.vue").then(m => m.default || m)
  },
  {
    name: callback_45reservebXNjSVEpRgMeta?.name ?? "contact-en-callback-reserve",
    path: callback_45reservebXNjSVEpRgMeta?.path ?? "/contact/en/callback-reserve",
    meta: callback_45reservebXNjSVEpRgMeta || {},
    alias: callback_45reservebXNjSVEpRgMeta?.alias || [],
    redirect: callback_45reservebXNjSVEpRgMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/callback-reserve.vue").then(m => m.default || m)
  },
  {
    name: contract_45switchlQBQV3ZetXMeta?.name ?? "contact-en-contract-switch",
    path: contract_45switchlQBQV3ZetXMeta?.path ?? "/contact/en/contract-switch",
    meta: contract_45switchlQBQV3ZetXMeta || {},
    alias: contract_45switchlQBQV3ZetXMeta?.alias || [],
    redirect: contract_45switchlQBQV3ZetXMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/contract-switch.vue").then(m => m.default || m)
  },
  {
    name: m_4500rIHyclOudEMeta?.name ?? "contact-en-m-00",
    path: m_4500rIHyclOudEMeta?.path ?? "/contact/en/m-00",
    meta: m_4500rIHyclOudEMeta || {},
    alias: m_4500rIHyclOudEMeta?.alias || [],
    redirect: m_4500rIHyclOudEMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-00.vue").then(m => m.default || m)
  },
  {
    name: m_4501gY78oKm1MVMeta?.name ?? "contact-en-m-01",
    path: m_4501gY78oKm1MVMeta?.path ?? "/contact/en/m-01",
    meta: m_4501gY78oKm1MVMeta || {},
    alias: m_4501gY78oKm1MVMeta?.alias || [],
    redirect: m_4501gY78oKm1MVMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-01.vue").then(m => m.default || m)
  },
  {
    name: m_4502OokD6e7MeFMeta?.name ?? "contact-en-m-02",
    path: m_4502OokD6e7MeFMeta?.path ?? "/contact/en/m-02",
    meta: m_4502OokD6e7MeFMeta || {},
    alias: m_4502OokD6e7MeFMeta?.alias || [],
    redirect: m_4502OokD6e7MeFMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-02.vue").then(m => m.default || m)
  },
  {
    name: m_45039h16O6NGW1Meta?.name ?? "contact-en-m-03",
    path: m_45039h16O6NGW1Meta?.path ?? "/contact/en/m-03",
    meta: m_45039h16O6NGW1Meta || {},
    alias: m_45039h16O6NGW1Meta?.alias || [],
    redirect: m_45039h16O6NGW1Meta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-03.vue").then(m => m.default || m)
  },
  {
    name: m_4504qy5W5HH8xoMeta?.name ?? "contact-en-m-04",
    path: m_4504qy5W5HH8xoMeta?.path ?? "/contact/en/m-04",
    meta: m_4504qy5W5HH8xoMeta || {},
    alias: m_4504qy5W5HH8xoMeta?.alias || [],
    redirect: m_4504qy5W5HH8xoMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-04.vue").then(m => m.default || m)
  },
  {
    name: m_4507oj8NC9tlakMeta?.name ?? "contact-en-m-07",
    path: m_4507oj8NC9tlakMeta?.path ?? "/contact/en/m-07",
    meta: m_4507oj8NC9tlakMeta || {},
    alias: m_4507oj8NC9tlakMeta?.alias || [],
    redirect: m_4507oj8NC9tlakMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-07.vue").then(m => m.default || m)
  },
  {
    name: m_45086ThglOICLNMeta?.name ?? "contact-en-m-08",
    path: m_45086ThglOICLNMeta?.path ?? "/contact/en/m-08",
    meta: m_45086ThglOICLNMeta || {},
    alias: m_45086ThglOICLNMeta?.alias || [],
    redirect: m_45086ThglOICLNMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/en/m-08.vue").then(m => m.default || m)
  },
  {
    name: touch_45de_45mail0pjKU81WDkMeta?.name ?? "contact-mb-touch-de-mail",
    path: touch_45de_45mail0pjKU81WDkMeta?.path ?? "/contact/mb/touch-de-mail",
    meta: touch_45de_45mail0pjKU81WDkMeta || {},
    alias: touch_45de_45mail0pjKU81WDkMeta?.alias || [],
    redirect: touch_45de_45mail0pjKU81WDkMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/mb/touch-de-mail.vue").then(m => m.default || m)
  },
  {
    name: saponaviyHxKNs9IWJMeta?.name ?? "contact-ym-saponavi",
    path: saponaviyHxKNs9IWJMeta?.path ?? "/contact/ym/saponavi",
    meta: saponaviyHxKNs9IWJMeta || {},
    alias: saponaviyHxKNs9IWJMeta?.alias || [],
    redirect: saponaviyHxKNs9IWJMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/contact/ym/saponavi.vue").then(m => m.default || m)
  },
  {
    name: indexAMyVc8flIhMeta?.name ?? "index",
    path: indexAMyVc8flIhMeta?.path ?? "/",
    meta: indexAMyVc8flIhMeta || {},
    alias: indexAMyVc8flIhMeta?.alias || [],
    redirect: indexAMyVc8flIhMeta?.redirect || undefined,
    component: () => import("C:/sb/workspace/sbform/src/pages/index.vue").then(m => m.default || m)
  }
]